module.exports = __webpack_public_path__ + "img/arrow-navigation.2fc4d1c2.svg";